import { FC, ReactNode } from 'react'

import LoadAnimation from '@/components/loadAnimation'

import { useMobilityTheme } from './useMobilityTheme'

interface MobilityThemeSwitchProps {
  /** The old UI, shown when the `mobility_theme` flag is off or the flags fail to load. */
  legacy: ReactNode
  /** The new theme, shown when the `mobility_theme` flag is on. */
  themed: ReactNode
}

/**
 * Shows the new or the old UI of a Mobility Manager page, from the `mobility_theme` feature flag.
 *
 * It shows a loader until the flags are loaded. If it showed the old UI while loading, a user
 * with the flag would see the old page first, then the new one, and the map would start twice.
 *
 * See `web/fe/docs/mobility-theme-flag.md` for how to put a page behind the flag.
 */
export const MobilityThemeSwitch: FC<MobilityThemeSwitchProps> = ({ legacy, themed }) => {
  const { isEnabled, isPending } = useMobilityTheme()

  if (isPending) return <LoadAnimation />

  return isEnabled ? themed : legacy
}
